export default "__VITE_ASSET__D8dg9Y92__"